import { render, staticRenderFns } from "./TrademarkViennaClassesForm.vue?vue&type=template&id=69e9a4ec&"
import script from "./TrademarkViennaClassesForm.vue?vue&type=script&lang=js&"
export * from "./TrademarkViennaClassesForm.vue?vue&type=script&lang=js&"
import style0 from "./TrademarkViennaClassesForm.vue?vue&type=style&index=0&id=69e9a4ec&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports